const leadingZero = (value: number) => {
    return value < 10 ? '0' + value : value;
};
export const createDateWithoutTimezone = (year: number, month: number, date: number) => {
    return new Date(year + '-' + leadingZero(month) + '-' + leadingZero(date) + 'T00:00:00+0000')
        .toISOString()
        .slice(0, -1);
};
